import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repository/RepositoryFactory";
let User = RepositoryFactory.get("user");
let Payment = RepositoryFactory.get("payment");

export const unsubscribe =
  (sub_id, uid, onSuccess, onError) => async (dispatch) => {
    try {
      await User.unSubscribe(sub_id);

      const usersRef = firebase.firestore().collection("users");
      const userDoc = await usersRef.doc(uid).get();
      const userData = userDoc.data();
      const currentSubscription = userData.subscription || {};
      await usersRef.doc(uid).update({
        subScriptionStatus: "unsubscribe",
        subscription: { ...currentSubscription, subscriptionID: "" },
      });

      onSuccess();
      toast.success("Subscription Cancelled Successfully!");
      dispatch({
        type: "UPDATE_SUBSCRIPTION_STATUS",
        payload: "unsubscribe",
      });
    } catch (error) {
      toast.error(error.message);
      onError();
    }
  };

export const upgradeSubscription =
  (currentSubscription, uid, setLoader, updateToggle) => async (dispatch) => {
    try {
      const previousSubscription =
        currentSubscription?.subscriptionPlan?.charAt(0) +
        currentSubscription?.subscriptionPlan?.slice(1);
      const res = await Payment.getPaymentPrices();
      const data = res?.data?.data || [];
      for (const record of data) {
        const nickName = record?.nickname;
        const subscription = nickName?.split(" ");
        const newSubscription = subscription[0]?.toLowerCase();
        if (newSubscription !== previousSubscription) {
          const planId = record?.id;
          const body = {
            plan: newSubscription,
            priceId: planId,
            subscriptionId: currentSubscription?.subscriptionID,
          };

          const response = await User.updateSubscription(body);
          const payload = {
            customerID: response?.data?.data?.subscription?.customer,
            subscriptionID: response?.data?.data?.subscription?.id,
            subscriptionPlan: newSubscription,
          };
          await firebase
            .firestore()
            .collection("users")
            .doc(uid)
            .update({ subscription: payload })
            .then(() => {
              toast.success("Subscription Updated Successfully.!");
              updateToggle();
              setLoader(false);
            })
            .catch((error) => {
              console.error(error.message);
            });
        }
      }
    } catch (error) {
      console.error("Error upgrading subscription:", error);
      toast.error("Failed to update subscription");
      setLoader(false);
    }
  };
async function deleteCheckoutResponses(questions) {
  for (var question of questions) {
    const querySnapshot = await firebase
      .firestore()
      .collection("checkoutResponses")
      .where("questionId", "==", question.id)
      .get();

    querySnapshot.forEach((doc) => {
      doc.ref.delete();
    });
  }
}

export const createSubscribe =
  (obj, uid, onSuccess, onError) => async (dispatch) => {
    await User.createSubscription(obj)
      .then(async (response) => {
        let payload = {
          customerID: response.data.data.customer.id,
          subscriptionID: response.data.data.subscription.id,
          subscriptionPlan: obj.plan,
        };
        await firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .update({ subscription: payload, subScriptionStatus: "subscribe" })
          .then(
            onSuccess(),
            toast.success("Re-Subscribe Successfuly.!"),
            dispatch({
              type: "UPDATE_SUBSCRIPTION_STATUS",
              payload: "subscribe",
            }),
            dispatch({
              type: "SETCOUPON",
              payload: {},
            })
          );
      })
      .catch((ex) => {
        toast.error(ex.message);
        console.error(ex.message);
        onError();
      });
  };

export const createNewSubscription =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    await User.createNewSubscription(payload).then(async (response) => {
      let { data } = response;
      window.location.href = data?.data;
      onSuccess();
    });
  };
export const AppyCoupon = (payload) => async (dispatch) => {
  dispatch(couponLoader(true));
  await User.CouponVerification(payload)
    .then(async (response) => {
      let { data } = response;
      dispatch({
        type: "SETCOUPON",
        payload: data,
      });
      dispatch(couponLoader(false));
    })
    .catch((error) => {
      toast.error("Invalid Coupon!");
      dispatch(couponLoader(false));
    });
};
const couponLoader = (data) => async (dispatch) => {
  dispatch({
    type: "COUPON_LOADER",
    payload: data,
  });
};
export const getSubscription =
  (uid, onSuccess = () => {}) =>
  (dispatch) => {
    try {
      const docRef = firebase.firestore().collection("subscriptions").doc(uid);

      const unsubscribe = docRef.onSnapshot((docSnap) => {
        if (docSnap.exists) {
          const data = docSnap.data();
          dispatch({
            type: "GET_SUBSCRIPTION",
            payload: data,
          });
        }
        onSuccess();
      });
      return unsubscribe;
    } catch (error) {
      console.error("Error setting up subscription snapshot:", error);
      toast.error("Something went wrong");
    }
  };
